import {createIcon} from '@chakra-ui/react'

export const MyobLogoInCircleIcon = createIcon({
  displayName: 'MyobLogoInCircleIcon',
  viewBox: '0 0 800 800',
  path: (
    <>
      <path
        d="M653.941 358.423C634.172 358.423 618.231 376.598 618.231 398.917C618.231 420.917 634.172 438.771 653.941 438.771C674.027 438.771 689.971 421.554 689.971 398.917C689.971 375.958 674.027 358.423 653.941 358.423Z"
        fill="url(#paint0_linear_15_4640)"
      />
      <path
        d="M499.3 357.468C480.488 357.468 464.863 374.685 464.863 398.917C464.863 422.83 480.488 439.411 499.3 439.411C518.43 439.411 534.053 422.83 534.053 398.917C534.053 374.685 518.428 357.468 499.3 357.468Z"
        fill="url(#paint1_linear_15_4640)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M400 800C620.914 800 800 620.914 800 400C800 179.086 620.914 0 400 0C179.086 0 0 179.086 0 400C0 620.914 179.086 800 400 800ZM581.88 289.868C582.198 281.581 586.345 265 610.895 265L618.231 265.003V341.526C628.752 331.005 643.099 324.945 659.361 324.945C696.027 324.945 726 356.828 726 398.919C726 440.369 696.027 472.254 659.361 472.254C642.462 472.254 627.476 465.876 616.636 454.397V455.671C616.315 460.772 613.129 469.699 599.098 469.381H581.88V289.868ZM499.3 472.57C460.4 472.57 428.833 441.005 428.833 398.917C428.833 356.51 460.4 324.306 499.3 324.306C538.518 324.306 570.083 356.51 570.083 398.917C570.083 441.005 538.518 472.57 499.3 472.57ZM136.134 324.303C155.264 324.303 170.89 331.954 180.772 344.388C191.615 331.954 207.235 324.306 225.41 324.306C264.947 324.306 287.902 350.451 287.902 387.438V441.003C287.587 464.919 271.643 468.744 263.671 469.381H251.873V386.798C251.873 378.829 249.324 359.699 225.407 359.699C209.784 359.699 198.308 370.857 198.308 386.801V441.642C197.669 464.919 182.046 468.744 174.074 469.381H162.279V386.798C162.279 378.829 160.048 359.699 136.132 359.699C120.19 359.699 109.029 370.857 109.029 386.798V441.324C108.393 464.919 92.7696 468.744 84.7975 469.381H73V387.438C73 351.408 97.8711 324.309 136.134 324.303ZM361.24 427.929L391.531 343.755C397.59 327.81 411.934 327.5 413.21 327.5H438.4L371.44 495.212C358.688 526.461 340.194 534.749 315.005 535.385L301.615 502.227V501.908C321.064 503.184 330.309 498.72 336.687 482.46L337.963 478.95C339.517 473.668 340.161 470.505 338.423 465.332C338.349 465.216 338.281 465.069 338.281 464.921L338.185 464.685C338.091 464.603 337.963 464.603 337.963 464.603C338.047 464.603 338.109 464.603 338.154 464.609L282.482 327.492H310.545C310.545 327.492 323.616 326.855 328.399 340.566L361.24 427.929Z"
        fill="url(#paint2_linear_15_4640)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15_4640"
          x1="1.00525e-07"
          y1="400"
          x2="800"
          y2="422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5F1C92" />
          <stop offset="0.25" stopColor="#7B329F" />
          <stop offset="0.75" stopColor="#B82494" />
          <stop offset="0.995192" stopColor="#ED0577" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15_4640"
          x1="1.00525e-07"
          y1="400"
          x2="800"
          y2="422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5F1C92" />
          <stop offset="0.25" stopColor="#7B329F" />
          <stop offset="0.75" stopColor="#B82494" />
          <stop offset="0.995192" stopColor="#ED0577" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_15_4640"
          x1="1.00525e-07"
          y1="400"
          x2="800"
          y2="422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5F1C92" />
          <stop offset="0.25" stopColor="#7B329F" />
          <stop offset="0.75" stopColor="#B82494" />
          <stop offset="0.995192" stopColor="#ED0577" />
        </linearGradient>
      </defs>
    </>
  ),
})
